import { render, staticRenderFns } from "./ElParagraph.vue?vue&type=template&id=290cd4be"
import script from "./ElParagraph.vue?vue&type=script&lang=js"
export * from "./ElParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports